import {parseResponse} from '../api'
import {NOT_NULL_MSG} from '../validation/messages'


export const AnalyticsRequestType = { // todo(egor): remove?
  Standard: 'Standard',
  ExecutedNotEqualRequested: 'ExecutedNotEqualRequested'
};

export const GetFilteredMetaFilters = {
  MoreThan1RawMaterial: 'MoreThan1RawMaterial',
  MoreThan4CreatedBlocks: 'MoreThan4CreatedBlocks',
  MoreThan0IhcSlidesCreated: 'MoreThan0IhcSlidesCreated',
  MoreThan0HcSlidesCreated: 'MoreThan0HcSlidesCreated',
// ExecutedPriceOver9000: 'ExecutedPriceOver9000', // work only on client side
};

export const GetFilteredCaseAnomalies = {
  IncomingRawMaterial: "IncomingRawMaterial",
  IHCSlidesCreated: "IHCSlidesCreated",
  HistoblockCreated: "HistoblockCreated",
  HCSlidesCreated: "HCSlidesCreated",
};

/**
 * @Grpc("su.unim.mcc.api.CaseServiceLogService")
 */
export default class CaseServiceLogService {
  constructor(axios) {
    // todo(egor): add config for domain
    this.axios = axios
  }

  getLogByCase({caseId}) {
    return this.axios.post(`/api/case/service-log/by-case`, {caseId})
      .then((response) => {
        return parseResponse(response)
      })
  }

  async addCaseService({caseId, serviceId, requested, executed}) {
    if (!caseId) {
      throw Error(`Wrong caseId: ${NOT_NULL_MSG}`)
    }

    if (!serviceId) {
      throw Error(`Wrong serviceId: ${NOT_NULL_MSG}`)
    }

    if (!requested.quantity) {
      throw Error(`Wrong quantity: ${NOT_NULL_MSG}`)
    }

    if (!requested.occurredAt) {
      throw Error(`Wrong occurredAt ${NOT_NULL_MSG}`)
    }

    if (requested.price) {
      if (requested.price < 0) {
        throw Error(`Wrong price ${NOT_NULL_MSG}`)
      }
    }

    if (executed != null) {
      if (!executed.quantity) {
        throw Error(`Wrong quantity: ${NOT_NULL_MSG}`)
      }

      if (!executed.occurredAt) {
        throw Error(`Wrong occurredAt ${NOT_NULL_MSG}`)
      }
    }

    return this.axios
      .post(`/api/case/service-log/add-service`, {
        caseId,
        serviceId,
        requested: {
          quantity: requested.quantity,
          occurredAt: requested.occurredAt,
          price: requested.price,
          comment: requested.comment
        },
        executed: executed
      })
      .then((response) => {
        return parseResponse(response)
      })
  }

  async deleteCaseService({caseId, serviceId, comment}) {
    if (!caseId) {
      throw Error(`Wrong caseId`)
    }

    if (!serviceId) {
      throw Error(`Wrong serviceId`)
    }

    return this.axios
      .post(`/api/case/service-log/delete-service`, {caseId, serviceId, comment})
      .then((response) => {
        return parseResponse(response)
      })
  }

  async addCaseServiceLog({caseId, serviceId, event, quantityChange, occurredAt, comment}) {
    if (!quantityChange || !occurredAt) {
      throw Error(`Wrong quantityChange, occurredAt: ${quantityChange} / ${occurredAt}`)
    }

    return this
      .axios.post(`/api/case/service-log/add`, {
        caseId,
        serviceId,
        event,
        quantityChange,
        occurredAt,
        metadata: {
          comment: comment
        }
      })
      .then((response) => {
        return parseResponse(response)
      })
  }

  async replaceCaseServiceLog({id, serviceId, quantityChange, comment}) {
    // todo(egor): add request validation
    return this.axios.post(`/api/case/service-log/replace`, {id, serviceId, quantityChange, comment})
      .then((response) => {
        return parseResponse(response)
      })
  }

  async deleteCaseServiceLog({id, comment}) {
    // todo(egor): add request validation
    return this.axios.post(`/api/case/service-log/delete`, {id, comment})
      .then((response) => {
        return parseResponse(response)
      })
  }

  async updateCaseServicesInfo({caseId}) {
    return this.axios.post(`/api/case/service-log/update-case-services-info`, {caseId})
      .then((response) => {
        return parseResponse(response)
      })
  }

  async updateAllCasesServicesInfo() {
    return this.axios.post(`/api/case/service-log/update-all-cases-services-info`)
      .then((response) => {
        return parseResponse(response)
      })
  }

  async getFiltered(request) {
    // todo(egor): add request validation

    return this.axios.post(`/api/case/service-log/filtered`, request)
      .then((response) => {
        return parseResponse(response)
      })
  }

  async getFilteredServicesAsCsv(request) {
    // todo(egor): add request validation

    return this.axios.post(`/api/cases/service-log/filtered-as-csv`, request)
  }

  async restartCaseToWork({caseId, services, ...other}) {
    if (!caseId) {
      throw Error(`caseId can't be null`)
    }

    if (!services || services.length <= 0) {
      throw Error(`at least one service should be set`)
    }

    return this
      .axios.post(`/api/case/service-log/restart-case-to-work`, {
        caseId,
        services,
        ...other
      })
      .then((response) => {
        return parseResponse(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/CaseServiceLogService.js